/**
 * routes.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import { NEW_CONVERSATION_ID } from "@services/dataClasses/ConversationData";
import appConfig from "../config";

/**
 * Routes used in the application
 */

const MAIN_PAGE = ``;

const routes = {
  LOGIN: `${MAIN_PAGE}/login`,
  HOME: `${MAIN_PAGE}/home/keypad`,
  CALL_HISTORY: `${MAIN_PAGE}/home/call_history`,
  CALL_HISTORY_DETAILS: `${MAIN_PAGE}/home/call_history/details`,
  KEYPAD: `${MAIN_PAGE}/home/keypad`,
  TEXT_MESSAGES: `${MAIN_PAGE}/home/text_messages`,
  TEXT_MESSAGE_SINGLE: `${MAIN_PAGE}/home/text_messages/:convId`,
  TEXT_MESSAGE_DETAILS: `${MAIN_PAGE}/home/text_messages/:convId/details`,
  VOICEMAIL: `${MAIN_PAGE}/home/voicemail`,
  VOICEMAIL_DETAILS: `${MAIN_PAGE}/home/voicemail/details`,
  MEETINGS: `${MAIN_PAGE}/home/meetings`,
  MEETINGS_IFRAME: `${MAIN_PAGE}/meetings/:action/:sessionKey?`,
  CALLER_ID: `${MAIN_PAGE}/preferences/caller_id`,
  CONTROLS: `${MAIN_PAGE}/preferences/controls`,
  NOTIFICATIONS_AND_SOUNDS: `${MAIN_PAGE}/preferences/notifications_and_sounds`,
  CALL_HISTORY_AND_REPORTING: `${MAIN_PAGE}/preferences/call_history_and_reporting`,
  TEXT_MESSAGE_HISTORY: `${MAIN_PAGE}/preferences/text_message_history`,
  FORWARDING_PHONE_NUMBERS: `${MAIN_PAGE}/preferences/forwarding_phone_numbers`,
  TRANSFER_CODES: `${MAIN_PAGE}/preferences/transfer_codes`,
  CONTACTS: `${MAIN_PAGE}/preferences/contacts`,
  HOURS_OF_OPERATION: `${MAIN_PAGE}/preferences/hours_of_operation`,
  GREETINGS_AND_MUSIC_ON_HOLD: `${MAIN_PAGE}/preferences/greetings_and_music_on_hold`,
  PREFERENCES_VOICEMAIL: `${MAIN_PAGE}/preferences/voicemail`,
  BLOCKED_NUMBERS: `${MAIN_PAGE}/preferences/blocked_numbers`
};

export const isPublicRoute = (pathname: string) => {
  // handles all pages at /meetings/join/*
  if (pathname.startsWith("/meetings/join")) return true;
  // /login
  if (pathname === "/login") return true;
  // every other path requires authentication
  return false;
}

export enum MeetingsRouteActions {
  JOIN_MEETING = "join",
  NEW_MEETING = "new",
  NEW_SCREENSHARING_MEETING = "screenshare",
}

/**
 * Builders for parametric URLs
 */
export const routeUrlBuilders = {
  MEETINGS_IFRAME: (action: MeetingsRouteActions, sessionKey?: string) =>
    `${MAIN_PAGE}/meetings/${action}/${sessionKey ?? ""}`,
  JOIN_MEETING_LINK: (sessionKey: string) =>
    `${
      appConfig.webAppUrl
    }meetings/${MeetingsRouteActions.JOIN_MEETING}/${sessionKey}`,
  OPEN_CONVERSATION: (convId: string, details = false) => 
     `${MAIN_PAGE}/home/text_messages/${convId === NEW_CONVERSATION_ID ? "new" : convId}${details ? '/details' : ''}`
  ,
};

export default routes;
